import { ConservationBenchmarkType } from '@/api/rest/resources/conservation';
import { BenchmarkType } from '@/api/rest/resources/types/fact';
import { Logger } from '@/lib/logs/logger';

import { resolveThemeColor } from './resolveThemeColor';

export type BenchmarkStyle = {
  primary: string;
  text: string;
};

const exhaustivenessCheck = (benchmark: never): BenchmarkStyle => {
  Logger.error(`No color defined for benchmark type "${benchmark}"`);
  return { primary: resolveThemeColor('transparent'), text: resolveThemeColor('transparent') };
};

export const getStyleForBenchmark = (benchmark: BenchmarkType): BenchmarkStyle => {
  switch (benchmark) {
    case BenchmarkType.low:
      return { primary: resolveThemeColor('error-light'), text: resolveThemeColor('error-dark') };
    case BenchmarkType.moderate:
      return { primary: resolveThemeColor('warning-light'), text: resolveThemeColor('warning-dark') };
    case BenchmarkType.high:
      return { primary: resolveThemeColor('success-light'), text: resolveThemeColor('success-dark') };
    default:
      return exhaustivenessCheck(benchmark);
  }
};

type ConservationBenchmarkStyle = {
  background: string;
  color: string;
};

const exhaustivenessConservationBenchmarkCheck = (benchmark: never): ConservationBenchmarkStyle => {
  Logger.error(`No color defined for benchmark type "${benchmark}"`);
  return { background: resolveThemeColor('transparent'), color: resolveThemeColor('transparent') };
};

export const getStyleForConservationBenchmark = (
  benchmark: ConservationBenchmarkType | never,
): ConservationBenchmarkStyle => {
  switch (benchmark) {
    case ConservationBenchmarkType.thriving:
      return {
        background: '#BFFFE6',
        color: '#285E2B',
      };
    case ConservationBenchmarkType.healthy:
      return {
        background: '#CFFFBF',
        color: '#285E2B',
      };
    case ConservationBenchmarkType.managing:
      return {
        background: '#E8F5B2',
        color: '#004C3D',
      };
    case ConservationBenchmarkType.fragile:
      return {
        background: '#FFF2D2',
        color: '#774200',
      };
    case ConservationBenchmarkType.degraded:
      return {
        background: '#F6D4C1',
        color: '#774200',
      };
    default:
      return exhaustivenessConservationBenchmarkCheck(benchmark);
  }
};
